const LABEL_STATUS = {
  DEFAULT: 'default',
  ERROR: 'error',
  PROCESSING: 'processing',
  SUCCESS: 'success',
  WARNING: 'warning',
};

export default LABEL_STATUS;
